<div class="page">

  <div class="pagehead">
    <div>
      <h1>Notifications</h1>
      <p>Updates and circulars from EasyRin — download attachments for your records</p>
    </div>
    <div class="filters">
      <div class="seg" role="tablist" aria-label="Attachment type">
        <button type="button" [class.on]="activeTab === 'img'" (click)="activeTab = 'img'">{{ imgLabel || 'Images' }}</button>
        <button type="button" [class.on]="activeTab === 'pdf'" (click)="activeTab = 'pdf'">{{ pdfLabel || 'PDFs' }}</button>
        <button type="button" [class.on]="activeTab === 'vdo'" (click)="activeTab = 'vdo'">{{ vdoLabel || 'Videos' }}</button>
      </div>
    </div>
  </div>

  <ng-container *ngIf="getRetailerNotificationsdata; else noteSkel">

    <!-- images -->
    <div class="notes" *ngIf="activeTab === 'img'">
      <ng-container *ngFor="let i of getRetailerNotificationsdata">
        <div class="card note" *ngIf="(i.attachurl) && (i.attachurl.includes('.jpg') || i.attachurl.includes('.jpeg') || i.attachurl.includes('.png'))">
          <p class="note-msg">{{ i.message }}</p>
          <a class="note-media" title="Download file" [href]="i.attachurl" target="_blank" download>
            <img [src]="i.attachurl" alt="Notification attachment">
          </a>
        </div>
      </ng-container>
      <div class="card page-empty" *ngIf="!imageCount">
        <span class="t">No image notifications</span>
      </div>
    </div>

    <!-- pdfs -->
    <div class="notes" *ngIf="activeTab === 'pdf'">
      <ng-container *ngFor="let i of getRetailerNotificationsdata">
        <div class="card note" *ngIf="i.attachurl.includes('.pdf')">
          <p class="note-msg">{{ i.message }}</p>
          <a class="note-media" title="Download file"
            *ngIf="((i.attachurl.includes('.pdf') || i.attachurl.includes('.PDF')) && i.previewattachurl)"
            [href]="i.attachurl" target="_blank" download>
            <img [src]="i.previewattachurl" alt="Document preview">
          </a>
        </div>
      </ng-container>
      <div class="card page-empty" *ngIf="!pdfCount">
        <span class="t">No document notifications</span>
      </div>
    </div>

    <!-- videos -->
    <div class="notes" *ngIf="activeTab === 'vdo'">
      <ng-container *ngFor="let i of getRetailerNotificationsdata">
        <div class="card note" *ngIf="i.attachurl.includes('.mp4')">
          <p class="note-msg">{{ i.message }}</p>
          <video class="note-video" controls>
            <source [src]="i.attachurl">
            Your browser does not support the video tag.
          </video>
        </div>
      </ng-container>
      <div class="card page-empty" *ngIf="!vdoCount">
        <span class="t">No video notifications</span>
      </div>
    </div>

  </ng-container>
  <ng-template #noteSkel>
    <div class="notes">
      <div class="card note" *ngFor="let i of [1,2,3]">
        <div class="er-skel er-skel--text" style="width:60%"></div>
        <div class="er-skel er-skel--card" style="width:120px;height:80px"></div>
      </div>
    </div>
  </ng-template>

</div>
